import React from 'react';
import { marqueeItems } from '../data/content';
import './Marquee.css';

export default function Marquee() {
  // Duplicate items for seamless loop
  const allItems = [...marqueeItems, ...marqueeItems];

  return (
    <div className="marquee-strip">
      <div className="marquee-track">
        {allItems.map((item, i) => (
          <div className="marquee-item" key={i}>
            <span className="marquee-dot" />
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}
